<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper confirmGoldUsage" style="z-index: 5000; opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small  confirmGoldUsage " ng-class="{inWindowPopupOpened: inWindowPopupOpened}">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('confirmAction')" class="closeWindow clickable"  play-on-click="7" @click="onModalClose(close)" content="Закрыть" v-tippy="{placement: 'bottom'}">
							<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" ng-class="::{static: w.params.modalParams.staticPosition}" class=" msAntiScroll" draggable="true">
							<span translate="" options="ConfirmGoldUsage.Title" data=""><span>Ты уверен?</span></span>
						</h2>
					</div>
					<div class="confirmActionContent" ng-class="::{disclaimer: disclaimer}" ng-controller="confirmGoldUsageCtrl">
						<i ng-if="::!heroCustomization" class="featureIcon premium_buildingMasterSlot_medium_illu"></i>
						<div class="description" translate="" data="price:50" options="buildingMasterSlot"><span>Открыть этот слот за 50 золота?</span></div>
						<div ng-if="::(featureName == PremiumFeature.FEATURE_NAME_BOOK_BUILD_MASTER_SLOT)">
							<span class="activationHint" translate=""><span>(На весь раунд во всех деревнях)</span></span><br><br>
						</div>
						<div class="horizontalLine"></div>
						<div class="buttons">
							<button class="cancel clickable" clickable="closeWindow('confirmGoldUsage')" @click="onModalClose(close)">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Отмена</span></span>
									</span>
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
							<button ng-if="::!confirmationRequestId" class="animate premium clickable" premium-feature="buildingMasterSlot" clickable="saveAndClose()" @click="onModalClose(close)" price="50" play-on-click="false">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate="" options="Unlock">
											<span>Открыть</span>
										</span>
									</span>
									<span class="price gold" ng-if="price > 0 || forceGoldUsage"><i class="unit_gold_small_illu"></i>50</span>
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
					</div>
					<div class="window-overlay" name="smallOverlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>